<template>
	<div class="personal-index max-content">
		<div class="head" @click="skipPage(4)">
			<img src="../../../assets/images/defaultHead.png" alt="" v-if="!userInfo||!userInfo.avatar">
			<img :src="userInfo.avatar" alt="" v-else>
			<div v-if="userInfo">
				<p>{{userInfo.nickname}}</p>
				<span class="expert" v-if="userInfo.is_writer==1">专家认证</span>
			</div>
		</div>
		<div class="hr-7" style="background:#f0f0f0"></div>
		<div class="content">
			<!-- <div class="item" @click="skipPage(0)">
				<div>
					<img src="../../../assets/images/System/register_icon.png" alt="">
					<span>身份认证</span>		
				</div>
				<p v-if="userInfo.has_authentication==0">去认证</p>	
				<p v-if="userInfo.has_authentication==1">已认证</p>		
				<van-icon name="arrow"/>
			</div> -->
			<!-- <div class="item"@click="skipPage(1)">
				<div>
					<img src="../../../assets/images/System/my_watch_icon.png" alt="">
					<span>我的关注</span>					
				</div>
				<van-icon name="arrow"/>
			</div> -->
			<div class="item"  @click="skipPage(2)">
				<div>
					<img src="../../../assets/images/System/my_collect_icon.png" alt="">
					<span>我的收藏</span>					
				</div>
				<van-icon name="arrow" />
			</div>
			<div class="item" @click="skipPage(3)">
				<div>
					<img src="../../../assets/images/System/task_book_icon.png" alt="">
					<span>任务书</span>					
				</div>
				<van-icon name="arrow"/>
			</div>
			<div class="item" @click="skipPage(5)">
				<div>
					<img src="../../../assets/images/System/setting_icon.png" alt="">
					<span>设置</span>					
				</div>
				<van-icon name="arrow" />
			</div>
		</div>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>
	import {PersoanalUserInfo} from "../../../config/interface.js"
	import Tabbar from "../components/Tabbar";
	export default{
		components:{
			Tabbar
		},
		data(){
			return{
				userInfo:'',  //用户信息
				index:4,    //tabbar中的index值
			}
		},
		created(){
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){

                }
                else{
                    this.$router.push({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		created(){
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){

                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){

		},
		methods:{
			//得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo.mobile_status){
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
			//点击跳转
			skipPage(type){
				if(this.userInfo){
					switch(type){
						case 0:
						this.$router.push({
							path:'/vascularNews/user/creditAuth',
						});
						break;
						// case 1:
						// this.$router.push({
						// 	path:'/vascularNews/personal/attention'
						// });
						// break;
						case 2:
						this.$router.push({
							path:'/vascularNews/personal/collect'
						});
						break;
						case 3:
						this.$router.push({
							path:'/vascularNews/personal/taskbook',
						});
						break;
						case 4:
						this.$router.push({
							path:'/vascularNews/personal/myInfo',
						});
						break;
						case 5:
						this.$router.push({
							path:'/vascularNews/personal/setting',
						});
						break;											
					}
				}else{
					let url=window.location.href;
					this.$router.replace({
						path:'/vascularNews/user/login',
						query:{
							url:url
						}
					})					
				}
			}
		}
	}
</script>
<style lang="scss">
	.personal-index{
		width:100%;
		height:100%;
		.head{
			background: url('../../../assets/images/System/me_background.png');
			margin:5px 5px;
			@include flex(row);
			/*justify-content:center;*/
			align-items:center;
			/*height:170px;*/
			height:120px;
			border-radius:.5rem;
			img{
				width:60px;
				height:60px;
				border-radius:50%;
				margin-left: 15px;
				margin-right:15px;
			}
			div{
				p{
					font-size:20px;
					font-weight:700;
					margin-bottom:10px;
					color: white;
				}
				span{
					font-size:14px;
					color: white;
				}
			}
			.expert{
					border: 1px solid white;
					}
		}
		.content{
			margin:0px 5px;
			padding:0px 12px;
			background: white;
			border-radius:.5rem;
			.item{
				@include flex(row);
				justify-content:space-between;
				align-items:center;
				border-bottom: thin solid #F6F6F6;
				height:60px;
				line-height:60px;
				div{
					img{
						vertical-align:middle;
						height:25px;
					}
					i{
						vertical-align:middle;
						font-size:25px;
						color:#F85158;
					}
					span{
						font-size: 15px;
						color: #666666;
						letter-spacing: 0.49px;
						margin-left:17px;
					}
				}
				p{
						display: inline;
						font-size:14px;
                    	color: #007AFC;
						padding-left:150px;
				}
				i{
					color:#cacaca;
				}

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Personal/Index.vue